import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TagIcon } from '@heroicons/react/24/outline';
import { Budget } from '../types/budget';
import { EntitiesManagementDialog } from './EntitiesManagementDialog';

interface EntitiesManagementButtonProps {
  budget: Budget;
  showText?: boolean;
  className?: string;
}

export const EntitiesManagementButton: React.FC<EntitiesManagementButtonProps> = ({
  budget,
  showText = true,
  className = '',
}) => {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const baseClasses =
    'flex items-center rounded-md border border-slate-500 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-slate-500 dark:bg-surface-700 dark:text-slate-300 dark:hover:bg-surface-600';
  const buttonClasses = className ? `${baseClasses} ${className}` : baseClasses;

  return (
    <>
      <button
        onClick={() => setIsDialogOpen(true)}
        className={buttonClasses}
        title={t('entities.management')}
      >
        <TagIcon className={`h-5 w-5 ${showText ? 'mr-2' : ''}`} />
        {showText && <span>{t('entities.categories')}</span>}
      </button>

      <EntitiesManagementDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        budget={budget}
      />
    </>
  );
};
